import FluencyIcon from 'core-ui/components/icons/fluencyIcon.vue'
import TastyButtonInline from 'core-ui/components/tasty/tastyButtonInline.vue'
import TastyButtonNavLink from 'core-ui/components/tasty/tastyButtonNavLink.vue'
import TastyAlert from 'core-ui/components/tasty/tastyAlert.vue'
import TastyListGroup from 'core-ui/components/tasty/tastyListGroup.vue'
import TastyListGroupItem from 'core-ui/components/tasty/tastyListGroupItem.vue'
import TastyRow from 'core-ui/components/tasty/tastyRow.vue'
import TastyCol from 'core-ui/components/tasty/tastyCol.vue'
import TastyCard from 'core-ui/components/tasty/tastyCard.vue'
import TastyAccordion from 'core-ui/components/tasty/tastyAccordion.vue'
import TastyButton from 'core-ui/components/tasty/tastyButton.vue'
import TastyButtonGroup from 'core-ui/components/tasty/tastyButtonGroup.vue'
import TastyModal from '../components/tasty/tastyModal.vue'
import TastyCollapse from '../components/tasty/tastyCollapse.vue'
import TastyDropdown from 'core-ui/components/tasty/tastyDropdown.vue'
import TastyDropdownItem from 'core-ui/components/tasty/tastyDropdownItem.vue'
import TastyDropdownText from 'core-ui/components/tasty/tastyDropdownText.vue'
import TastyDropdownHeader from 'core-ui/components/tasty/tastyDropdownHeader.vue'
import TastyDropdownContent from 'core-ui/components/tasty/tastyDropdownContent.vue'
import TastyDropdownDivider from 'core-ui/components/tasty/tastyDropdownDivider.vue'
import TastyDropdownGroup from 'core-ui/components/tasty/tastyDropdownGroup.vue'
import TastySelectListbox from 'core-ui/components/tasty/tastySelectListbox.vue'
import TastyMultiInput from '../components/tasty/tastyMultiInput.vue'
import TastyFormGroup from '../components/tasty/tastyFormGroup.vue'
import TastyCheckbox from 'core-ui/components/tasty/tastyCheckbox.vue'
import TastyCheckboxGroup from 'core-ui/components/tasty/tastyCheckboxGroup.vue'
import TastyRadio from 'core-ui/components/tasty/tastyRadio.vue'
import TastyRadioGroup from 'core-ui/components/tasty/tastyRadioGroup.vue'
import TastyForm from '../components/tasty/tastyAutoComplete.vue'
import InfoTooltip from 'core-ui/components/common/infoTooltip.vue'
import TastyAutoComplete from '../components/tasty/tastyAutoComplete.vue'
import TastyColorPicker from '../components/tasty/tastyColorPicker.vue'
import TastyDataTable from '../components/tasty/tastyDataTable.vue'
import TastyDynamicField from '../components/tasty/tastyDynamicField.vue'

export const FluencyComponentsPlugin = {
  install (Vue, options) {
    Vue.component('FluencyIcon', FluencyIcon)
    Vue.component('InfoTooltip', InfoTooltip)
    Vue.component('t-button-inline', TastyButtonInline)
    Vue.component('t-button-nav-link', TastyButtonNavLink)
    Vue.component('t-list-group', TastyListGroup)
    Vue.component('t-list-group-item', TastyListGroupItem)
    Vue.component('t-row', TastyRow)
    Vue.component('t-col', TastyCol)
    Vue.component('t-alert', TastyAlert)
    Vue.component('t-card', TastyCard)
    Vue.component('t-accordion', TastyAccordion)
    Vue.component('t-button', TastyButton)
    Vue.component('t-btn', TastyButton)
    Vue.component('t-button-group', TastyButtonGroup)
    Vue.component('t-modal', TastyModal)
    Vue.component('t-collapse', TastyCollapse)
    Vue.component('t-dropdown', TastyDropdown)
    Vue.component('t-dropdown-item', TastyDropdownItem)
    Vue.component('t-dropdown-item-button', TastyDropdownItem)
    Vue.component('t-dropdown-text', TastyDropdownText)
    Vue.component('t-dropdown-header', TastyDropdownHeader)
    Vue.component('t-dropdown-content', TastyDropdownContent)
    Vue.component('t-dropdown-divider', TastyDropdownDivider)
    Vue.component('t-dropdown-group', TastyDropdownGroup)
    Vue.component('t-checkbox', TastyCheckbox)
    Vue.component('t-checkbox-group', TastyCheckboxGroup)
    Vue.component('t-select-listbox', TastySelectListbox)
    Vue.component('t-form-group', TastyFormGroup)
    Vue.component('t-radio', TastyRadio)
    Vue.component('t-radio-group', TastyRadioGroup)
    Vue.component('t-multi-input', TastyMultiInput)
    Vue.component('t-auto-complete', TastyAutoComplete)
    Vue.component('t-color-picker', TastyColorPicker)
    Vue.component('t-data-table', TastyDataTable)
    Vue.component('t-table', TastyDataTable)
    Vue.component('t-dynamic-field', TastyDynamicField)
    Vue.component('t-data-table', TastyDataTable)
    Vue.component('t-table', TastyDataTable)
  }
}

export default {
  install (Vue, options) {
    FluencyComponentsPlugin.install(Vue, options)
  }
}
